import { readCookie, CookieKeys } from './cookie-key';

export const { customerData } = CookieKeys;
export const { cancellationReviewData } = CookieKeys;
export const { anonymousReviewKey } = CookieKeys;

export default readCookie;
